<main class="main">
  <div class="header">
    <mat-toolbar class="header-toolbar">
      <span><a class="header-link" [routerLink]='["/"]'>{{ title() }}</a></span>
      <span class="ml-4"><mat-progress-spinner [hidden]="!showSpinner()" [diameter]="32" mode="indeterminate"></mat-progress-spinner></span>
      <span class="header-spacer"></span>
      @if(loggedIn()) {
        <span class="account-info">{{ getAccountName() }}</span>
        <button mat-button (click)="logout()">Logout</button>
      } @else {
        <button mat-button (click)="login()">Login</button>
      }
    </mat-toolbar>
  </div>

  <div class="content">
    <mat-sidenav-container class="layout-container">

      <mat-sidenav class="app-sidenav" mode="side" opened>
        <nav aria-label="Hauptnavigation">
          <mat-nav-list>
            <a mat-list-item [routerLink]='["/kassenzeichen"]'
               routerLinkActive #rla1="routerLinkActive" [activated]="rla1.isActive">
              <mat-icon matListItemIcon>badge</mat-icon>
              <span matListItemTitle>Kassenzeichen</span>
            </a>

            <a mat-list-item [routerLink]='["/zaehler-antraege"]'
               routerLinkActive #rla2="routerLinkActive" [activated]="rla2.isActive">
              <mat-icon matListItemIcon>fact_check</mat-icon>
              <span matListItemTitle>Zähler Anträge</span>
            </a>

            <a mat-list-item [routerLink]='["/zaehler"]'
               routerLinkActive #rla3="routerLinkActive" [activated]="rla3.isActive">
              <mat-icon matListItemIcon>water_drop</mat-icon>
              <span matListItemTitle>Zähler</span>
            </a>

            <a mat-list-item [routerLink]='["/ablesungen"]'
               routerLinkActive #rla4="routerLinkActive" [activated]="rla4.isActive">
              <mat-icon matListItemIcon>list_alt</mat-icon>
              <span matListItemTitle>Ablesungen</span>
            </a>
          </mat-nav-list>
        </nav>
      </mat-sidenav>

      <mat-sidenav-content class="app-content">
        <router-outlet></router-outlet>
      </mat-sidenav-content>

    </mat-sidenav-container>
  </div>

  <div class="flex text-tiny items-end text-gray-500 bg-blue-100 border-t p-1">
    <span class="font-bold">Gartenwasserzähler-Admin</span>
    <span class="flex-1 text-right"><app-client-version-component></app-client-version-component></span>
    <span>&nbsp;</span>
    <span>&copy;2026 by EUV Stadtbetrieb Castrop-Rauxel -AöR-</span>
  </div>
</main>
